import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { MessageSquareIcon, UsersIcon, ClockIcon, ArrowRightIcon, XIcon, PlusIcon, SearchIcon, CheckCircleIcon, ChevronRightIcon, AlertCircleIcon } from 'lucide-react';
const groups = [{
  id: 1,
  name: 'Zero Sprechi (Italia)',
  description: 'Consigli pratici per ridurre sprechi e rifiuti ogni giorno.',
  tags: ['zero waste', 'riuso', 'spesa'],
  members: 2348,
  lastActivity: 'Ultimo post: "Trucchi per conservare frutta e verdura"',
  lastActivityTime: '2 ore fa',
  isMember: true,
  image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80'
}, {
  id: 2,
  name: 'Mobilità Smart & Bici',
  description: 'Percorsi, sicurezza e idee per muoversi meglio in città.',
  tags: ['bici', 'trasporti', 'città'],
  members: 1126,
  lastActivity: 'Ultimo post: "Itinerari casa-lavoro: condividiamo mappe"',
  lastActivityTime: '6 ore fa',
  isMember: true,
  image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80'
}, {
  id: 3,
  name: 'Green Food & Spesa Consapevole',
  description: "Ricette semplici, stagionalità e scelte d'acquisto più sostenibili.",
  tags: ['cibo', 'stagionale', 'anti-spreco'],
  members: 3041,
  lastActivity: 'Ultimo post: "Lista spesa di stagione (settimana)"',
  lastActivityTime: '1 giorno fa',
  isMember: true,
  image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=800&q=80'
}];
const GroupsPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeFilter, setActiveFilter] = useState<'all' | 'active' | 'nearby'>('all');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return <div className="flex h-screen bg-gray-50" data-id="element-2558">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2559">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2560"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2561">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2562">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2563">
              <span className="sr-only" data-id="element-2564">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2565" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2566">
            <Sidebar activePage="community" data-id="element-2567" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2568">
        <Sidebar activePage="community" data-id="element-2569" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2570">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2571" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-50" data-id="element-2572">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-2573">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4" data-id="element-2574">
              <div data-id="element-2575">
                <h1 className="text-2xl font-semibold text-gray-800" data-id="element-2576">Gruppi</h1>
                <p className="text-gray-600 mt-1 text-sm font-normal" data-id="element-2577">
                  Esplora, unisciti o crea nuovi gruppi di discussione
                </p>
              </div>
              <button onClick={() => setIsCreateModalOpen(true)} className="flex items-center justify-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors font-medium text-sm" data-id="element-2578">
                <PlusIcon size={18} className="mr-2" strokeWidth={1.5} data-id="element-2579" />
                Crea Gruppo
              </button>
            </div>

            {/* Search and Filters */}
            <div className="mb-6 space-y-4" data-id="element-2580">
              {/* Search Bar */}
              <div className="relative" data-id="element-2581">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2582">
                  <SearchIcon size={18} className="text-gray-400" strokeWidth={1.5} data-id="element-2583" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm font-normal" placeholder="Cerca gruppi..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2584" />
              </div>

              {/* Filter Tabs */}
              <div className="flex bg-white rounded-lg p-1 border border-gray-200 overflow-x-auto" data-id="element-2585">
                <button onClick={() => setActiveFilter('all')} className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap transition-colors ${activeFilter === 'all' ? 'bg-green-100 text-green-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-2586">
                  Tutti
                </button>
                <button onClick={() => setActiveFilter('active')} className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap transition-colors ${activeFilter === 'active' ? 'bg-green-100 text-green-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-2587">
                  Più attivi
                </button>
                <button onClick={() => setActiveFilter('nearby')} className={`px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap transition-colors ${activeFilter === 'nearby' ? 'bg-green-100 text-green-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-2588">
                  Vicini a me
                </button>
              </div>
            </div>

            {/* Groups List */}
            <div className="space-y-4" data-id="element-2589">
              {groups.map(group => <GroupCard key={group.id} group={group} data-id="element-2590" />)}
            </div>
          </div>
        </main>
      </div>

      {/* Create Group Modal */}
      <CreateGroupModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} data-id="element-2591" />
    </div>;
};
interface GroupCardProps {
  group: {
    id: number;
    name: string;
    description: string;
    tags: string[];
    members: number;
    lastActivity: string;
    lastActivityTime: string;
    isMember: boolean;
    image: string;
  };
}
const GroupCard: React.FC<GroupCardProps> = ({
  group
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 hover:border-green-600 transition-all hover:shadow-sm overflow-hidden" data-id="element-2592">
      <div className="flex flex-col sm:flex-row" data-id="element-2593">
        {/* Group Image */}
        <div className="w-full sm:w-48 h-48 sm:h-auto flex-shrink-0" data-id="element-2594">
          <img src={group.image} alt={group.name} className="w-full h-full object-cover" data-id="element-2595" />
        </div>

        {/* Content */}
        <div className="p-5 flex-1" data-id="element-2596">
          {/* Header with Title and Badge */}
          <div className="flex items-start justify-between mb-3" data-id="element-2597">
            <div className="flex-1" data-id="element-2598">
              <h3 className="text-lg font-semibold text-gray-800 mb-1" data-id="element-2599">
                {group.name}
              </h3>
              <p className="text-sm text-gray-600 font-normal leading-relaxed" data-id="element-2600">
                {group.description}
              </p>
            </div>
            {group.isMember && <span className="ml-3 flex items-center px-2.5 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium whitespace-nowrap" data-id="element-2601">
                <CheckCircleIcon size={12} className="mr-1" strokeWidth={2} data-id="element-2602" />
                Sei membro
              </span>}
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-4" data-id="element-2603">
            {group.tags.map((tag, index) => <span key={index} className="px-2.5 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-normal" data-id="element-2604">
                {tag}
              </span>)}
          </div>

          {/* Stats and Activity */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4 pb-4 border-b border-gray-100" data-id="element-2605">
            <div className="flex items-center text-gray-500" data-id="element-2606">
              <UsersIcon size={16} className="mr-1.5" strokeWidth={1.5} data-id="element-2607" />
              <span className="text-sm font-normal" data-id="element-2608">
                {group.members.toLocaleString('it-IT')} membri
              </span>
            </div>
            <div className="flex items-center text-gray-500" data-id="element-2609">
              <MessageSquareIcon size={16} className="mr-1.5" strokeWidth={1.5} data-id="element-2610" />
              <span className="text-sm font-normal" data-id="element-2611">{group.lastActivity}</span>
            </div>
          </div>

          {/* Last Activity Time */}
          <div className="flex items-center justify-between" data-id="element-2612">
            <div className="flex items-center text-gray-400 text-xs font-normal" data-id="element-2613">
              <ClockIcon size={14} className="mr-1" strokeWidth={1.5} data-id="element-2614" />
              {group.lastActivityTime}
            </div>
            <Link to={`/groups/${group.id}`} className="flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors text-sm font-medium" data-id="element-2615">
              Apri
              <ArrowRightIcon size={16} className="ml-1.5" strokeWidth={1.5} data-id="element-2616" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
interface CreateGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const CreateGroupModal: React.FC<CreateGroupModalProps> = ({
  isOpen,
  onClose
}) => {
  const [step, setStep] = useState(1);
  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const availableTags = ['zero waste', 'riuso', 'spesa', 'bici', 'trasporti', 'città', 'cibo', 'stagionale', 'anti-spreco', 'energia', 'casa', 'mobilità'];
  const handleTagToggle = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else if (selectedTags.length < 5) {
      setSelectedTags([...selectedTags, tag]);
    }
  };
  const handleSubmit = () => {
    // In a real app, this would make an API call
    console.log({
      groupName,
      groupDescription,
      selectedTags
    });
    alert('Richiesta di creazione gruppo inviata! Riceverai una notifica quando sarà approvato.');
    onClose();
    // Reset form
    setStep(1);
    setGroupName('');
    setGroupDescription('');
    setSelectedTags([]);
  };
  const handleClose = () => {
    onClose();
    // Reset form after animation
    setTimeout(() => {
      setStep(1);
      setGroupName('');
      setGroupDescription('');
      setSelectedTags([]);
    }, 300);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-2617">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-2618">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={handleClose} data-id="element-2619"></div>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-2620">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-2621">
            {/* Header */}
            <div className="flex justify-between items-center mb-6" data-id="element-2622">
              <div data-id="element-2623">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2624">
                  Crea un nuovo gruppo
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-2625">Passo {step} di 3</p>
              </div>
              <button onClick={handleClose} className="text-gray-400 hover:text-gray-500" data-id="element-2626">
                <XIcon size={20} strokeWidth={1.5} data-id="element-2627" />
              </button>
            </div>

            {/* Progress Bar */}
            <div className="mb-6" data-id="element-2628">
              <div className="flex space-x-2" data-id="element-2629">
                <div className={`flex-1 h-1 rounded-full ${step >= 1 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-2630"></div>
                <div className={`flex-1 h-1 rounded-full ${step >= 2 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-2631"></div>
                <div className={`flex-1 h-1 rounded-full ${step >= 3 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-2632"></div>
              </div>
            </div>

            {/* Step Content */}
            {step === 1 && <div className="space-y-4" data-id="element-2633">
                <div data-id="element-2634">
                  <label htmlFor="groupName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2635">
                    Nome del gruppo
                  </label>
                  <input type="text" id="groupName" value={groupName} onChange={e => setGroupName(e.target.value)} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm" placeholder="Es: Mobilità Sostenibile Milano" data-id="element-2636" />
                </div>
                <div data-id="element-2637">
                  <label htmlFor="groupDescription" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2638">
                    Descrizione
                  </label>
                  <textarea id="groupDescription" value={groupDescription} onChange={e => setGroupDescription(e.target.value)} rows={4} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm" placeholder="Descrivi brevemente lo scopo del gruppo..." data-id="element-2639"></textarea>
                </div>
              </div>}

            {step === 2 && <div className="space-y-4" data-id="element-2640">
                <div data-id="element-2641">
                  <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-2642">
                    Tag selezionati ({selectedTags.length} / 5)
                  </label>
                  {selectedTags.length > 0 && <div className="flex flex-wrap gap-2 mb-4 p-3 bg-gray-50 rounded-lg" data-id="element-2643">
                      {selectedTags.map(tag => <span key={tag} className="inline-flex items-center px-3 py-1.5 rounded-full text-sm bg-green-600 text-white" data-id="element-2644">
                          {tag}
                          <button type="button" onClick={() => handleRemoveTag(tag)} className="ml-2 hover:text-green-200 transition-colors" data-id="element-2645">
                            <XIcon size={14} strokeWidth={2} data-id="element-2646" />
                          </button>
                        </span>)}
                    </div>}
                </div>

                <div data-id="element-2647">
                  <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-2648">
                    Tag suggeriti
                  </label>
                  <div className="flex flex-wrap gap-2" data-id="element-2649">
                    {availableTags.map(tag => <button key={tag} type="button" onClick={() => handleTagToggle(tag)} disabled={selectedTags.length >= 5 && !selectedTags.includes(tag)} className={`px-3 py-1.5 rounded-full text-sm transition-colors ${selectedTags.includes(tag) ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} ${selectedTags.length >= 5 && !selectedTags.includes(tag) ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-2650">
                        {tag}
                      </button>)}
                  </div>
                </div>

                <div data-id="element-2651">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2652">
                    Aggiungi tag personalizzato
                  </label>
                  <div className="flex gap-2" data-id="element-2653">
                    <input type="text" value={customTag} onChange={e => setCustomTag(e.target.value)} onKeyPress={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddCustomTag();
                  }
                }} disabled={selectedTags.length >= 5} className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Es: compostaggio" data-id="element-2654" />
                    <button type="button" onClick={handleAddCustomTag} disabled={!customTag.trim() || selectedTags.length >= 5} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2655">
                      Aggiungi
                    </button>
                  </div>
                  <p className="text-xs text-gray-500 mt-2" data-id="element-2656">
                    Premi Invio o clicca Aggiungi per creare un tag
                    personalizzato
                  </p>
                </div>
              </div>}

            {step === 3 && <div className="space-y-4" data-id="element-2657">
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-2658">
                  <div className="flex items-start" data-id="element-2659">
                    <AlertCircleIcon className="text-yellow-600 mt-0.5 mr-3 flex-shrink-0" size={20} strokeWidth={1.5} data-id="element-2660" />
                    <div className="text-sm text-yellow-800" data-id="element-2661">
                      <p className="font-medium mb-1" data-id="element-2662">Approvazione richiesta</p>
                      <p className="leading-relaxed" data-id="element-2663">
                        Il tuo gruppo sarà inviato per l'approvazione. Non sarà
                        visibile pubblicamente fino a quando un amministratore
                        Greenback non lo avrà revisionato e approvato. Riceverai
                        una notifica via email quando il gruppo sarà attivo.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-4 space-y-3" data-id="element-2664">
                  <h4 className="font-medium text-gray-900" data-id="element-2665">Riepilogo</h4>
                  <div data-id="element-2666">
                    <p className="text-xs text-gray-500 mb-1" data-id="element-2667">Nome gruppo</p>
                    <p className="text-sm text-gray-900" data-id="element-2668">{groupName}</p>
                  </div>
                  <div data-id="element-2669">
                    <p className="text-xs text-gray-500 mb-1" data-id="element-2670">Descrizione</p>
                    <p className="text-sm text-gray-900" data-id="element-2671">{groupDescription}</p>
                  </div>
                  <div data-id="element-2672">
                    <p className="text-xs text-gray-500 mb-1" data-id="element-2673">Tag</p>
                    <div className="flex flex-wrap gap-1" data-id="element-2674">
                      {selectedTags.map(tag => <span key={tag} className="px-2 py-0.5 bg-gray-200 text-gray-700 rounded-full text-xs" data-id="element-2675">
                          {tag}
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>}
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-3" data-id="element-2676">
            {step < 3 ? <>
                <button type="button" onClick={() => setStep(step + 1)} disabled={step === 1 && (!groupName || !groupDescription)} className="w-full inline-flex justify-center items-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2677">
                  Avanti
                  <ChevronRightIcon size={16} className="ml-1" strokeWidth={1.5} data-id="element-2678" />
                </button>
                {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className="mt-3 w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:w-auto sm:text-sm" data-id="element-2679">
                    Indietro
                  </button>}
              </> : <>
                <button type="button" onClick={handleSubmit} className="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm" data-id="element-2680">
                  Invia richiesta
                </button>
                <button type="button" onClick={() => setStep(step - 1)} className="mt-3 w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:w-auto sm:text-sm" data-id="element-2681">
                  Indietro
                </button>
              </>}
          </div>
        </div>
      </div>
    </div>;
};
export default GroupsPage;